<ng-container [formGroup]="form">
    <label [attr.for]="control.id">{{ control.label }}<span class="errorMessage" *ngIf="isValid"> *</span></label>

    <ng-container [ngSwitch]="control.controlType">
        <input *ngSwitchCase="'text'" class="form-control" type="text" [id]="control.id" (blur)="saveData()"
            [formControlName]="control.id" [placeholder]="control.placeholder" />
        <input *ngSwitchCase="'date'" class="form-control" type="date" [id]="control.id" (blur)="saveData()"
            min="0001-01-01" max="9999-01-01"
            [formControlName]="control.id" [placeholder]="control.placeholder" />
        <input *ngSwitchCase="'time'" class="form-control" type="time" [id]="control.id" (blur)="saveData()"
            [formControlName]="control.id" [placeholder]="control.placeholder" />
        <input *ngSwitchCase="'datetime-local'" class="form-control" type="datetime-local" [id]="control.id"
            max="9999-12-31T23:59"   
            (blur)="saveData()" [formControlName]="control.id" [placeholder]="control.placeholder" />
        <input *ngSwitchCase="'email'" type="email" class="form-control" [id]="control.id" (blur)="saveData()"
            [formControlName]="control.id" [placeholder]="control.placeholder" />
        <input *ngSwitchCase="'number'" type="number" class="form-control" [id]="control.id" (blur)="saveData()"
            [formControlName]="control.id" [placeholder]="control.placeholder" />
        <textarea *ngSwitchCase="'textarea'" class="form-control" [id]="control.id" [formControlName]="control.id"
            (blur)="saveData()" [placeholder]="control.placeholder" rows="3" cols="30">
        </textarea>
        <input *ngSwitchCase="'phone'" class="form-control" type="text" [id]="control.id" (blur)="saveData()"
            [formControlName]="control.id" [placeholder]="control.placeholder" />
        <input *ngSwitchCase="'url'" class="form-control" type="text" [id]="control.id" (blur)="saveData()"
            [formControlName]="control.id" [placeholder]="control.placeholder" />
          
            <div *ngSwitchCase="'radio'">
              <div *ngFor="let item of control.options">
                <label class="radio-alignment">
                  <ng-container *ngIf="control.dataSetEnabled; else customOptions">
                      <input type="radio" [value]="item" [formControlName]="control.id" (blur)="saveSelectData(control.id, item)">
                      <span>{{item.display.fieldValue}}</span>

                  </ng-container>
                  <ng-template #customOptions>
  
                     <input type="radio" [value]="item.display" [formControlName]="control.id" (blur)="saveData()">
                      <span>{{item.display}}</span>
                  
                  </ng-template>
                </label>
              </div>
            </div>

        <div *ngSwitchCase="'image'" class="custom-image-section fileInputProfileWrap">
            <div class="radio-alignment">
              <input *ngIf="!cardImageBase64" type="file" (change)="handleImageChange(control.id, $event)"
               class="fileInputProfile" accept="image/*">
          
              <div class="img-space">
                <ng-container *ngIf="isImageSaved">                
                    <img [src]="cardImageBase64" (click)="openImageInNewTab(cardImageBase64)"/>
                </ng-container>
              </div>
              <div class="btn-close-alignment">
                <button class="btn btn-light-primary font-weight-bolder font-size-h6 btn-close" (click)="removeImage(control.id)" *ngIf="isImageSaved && canDelete">x</button>
              </div>
            </div>
        </div>

        <div *ngSwitchCase="'file'" class="custom-file-section fileInputProfileWrap">
            <div class="radio-alignment">
              <input type="file" *ngIf="!isFileSaved" (change)="handleFileChange(control.id, $event)"
                accept=".xls, .xlsx, .pdf, .csv">
          
              <div class="custom-file-container"> 
                <ng-container *ngIf="isFileSaved">
                    <i class="fas fa-file-alt"></i>
                    <span> {{ fileName }}</span>
                </ng-container>
              </div>
              <div class="btn-close-alignment">
                <button class="btn btn-light-primary font-weight-bolder font-size-h6 btn-close" (click)="removeFile(control.id)"
                    *ngIf="isFileSaved && canDelete" >x</button>
               </div>
            </div>
          </div>
          

          

          <div *ngSwitchCase="'checkbox'" >
            <div *ngFor="let item of control.options;let i = index"  >
                <label class="radio-alignment">                    
                      <ng-container *ngIf="control.dataSetEnabled; else customOptions">
                        <input type="checkbox" [checked]="item.value==='true'" [id]="item.display.fieldId"
                        (change)="saveCheckData(control.id,$event)" [disabled]="!canDelete">
                        <span>{{item.display.fieldValue}}</span>
                      </ng-container>
                      <ng-template #customOptions>
                        <input type="checkbox" [checked]="item.value==='true'" [id]="item.id"
                        (change)="saveCheckData(control.id,$event)" [disabled]="!canDelete">
                        <span>{{item.display}}</span>
                      </ng-template>
                    
                </label>
            </div>
          </div>

        <div *ngSwitchCase="'selectlist'">
            <app-control-selectlist [isReadOnly]="isReadOnly" [compareWith]="control.dataSetEnabled == true ? objectComparisonFunction : nullComparisonFunction"
                [controlData]="control"
                (selectionChange)="saveSelectData(control.id, $event)"
                [selectedValue]="form.get(control.id)?.value"
                >
            </app-control-selectlist>
          </div>

        <!-- <select *ngSwitchCase="'options'" class="form-control" type="text" [id]="control.id" (blur)="saveData()"
            [formControlName]="control.id" [placeholder]="control.placeholder">
            <option *ngFor="let state of options" [ngValue]="state">{{ state.display }}</option>
        </select> -->
    </ng-container>

    <div class="errorMessage" *ngIf="isValid">
        {{ control.label }} is required
    </div>
    <div class="errorMessage">
        {{ isValidRegex }}
    </div>
</ng-container>
